import {
  faEnvelope,
  faFile,
  faFileSignature,
  faStickyNote,
  faStream,
  faUser,
} from "@fortawesome/pro-regular-svg-icons";

export enum OpportunityPageTabs {
  ACTIVITY = "activity",
  EMAILS = "emails",
  NOTES = "notes",
  TASKS = "tasks",
  FILES = "files",
  CONTACTS = "contacts",
  DOCUSIGN = "docusign",
}

export const opportunityPageTabs = [
  {
    id: OpportunityPageTabs.ACTIVITY,
    label: "Activity",
    fontAwesomeIcon: faStream,
  },
  {
    id: OpportunityPageTabs.EMAILS,
    label: "Emails",
    fontAwesomeIcon: faEnvelope,
  },
  {
    id: OpportunityPageTabs.NOTES,
    label: "Notes",
    fontAwesomeIcon: faStickyNote,
  },
  // {
  //   id: OpportunityPageTabs.TASKS,
  //   label: "Tasks",
  //   fontAwesomeIcon: faTasks,
  // },
  {
    id: OpportunityPageTabs.FILES,
    label: "Files",
    fontAwesomeIcon: faFile,
  },
  {
    id: OpportunityPageTabs.CONTACTS,
    label: "Contacts",
    fontAwesomeIcon: faUser,
  },
  {
    id: OpportunityPageTabs.DOCUSIGN,
    label: "Docusign",
    fontAwesomeIcon: faFileSignature,
  },
];
